"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableRowsByRows = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _expander = require("../../expander");

var _layout = require("../../layout");

var _html = require("../html");

var _utils = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["columns", "data", "expandableContent", "expandableContentHasBackgroundColor", "expandableRowHasTopBorder", "index", "isExpanded", "isStriped", "shouldAnimateImmediately", "spacing", "ariaRowIndex"];

var ExpandableRowsByRows = function ExpandableRowsByRows(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      getRowExpandableContent = _ref.expandableContent,
      expandableContentHasBackgroundColor = _ref.expandableContentHasBackgroundColor,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      index = _ref.index,
      isExpanded = _ref.isExpanded,
      isStriped = _ref.isStriped,
      shouldAnimateImmediately = _ref.shouldAnimateImmediately,
      spacing = _ref.spacing,
      ariaRowIndex = _ref.ariaRowIndex,
      trProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return !!getRowExpandableContent ? (0, _core.jsx)(_react.default.Fragment, null, getRowExpandableContent({
    data: data,
    index: index
  }).map(function (ExpandableRowContent, expRowIndex) {
    return (0, _core.jsx)(_html.TrElement, (0, _extends2.default)({}, trProps, {
      key: expRowIndex,
      isExpandableContent: true,
      hasBackgroundColor: isStriped || expandableContentHasBackgroundColor,
      hasTopBorderWhenExpanded: expandableRowHasTopBorder && isExpanded,
      "aria-rowindex": // +1: expanded rows should start from prev row index+1
      isExpanded && ariaRowIndex ? ariaRowIndex + expRowIndex + 1 : undefined,
      "aria-hidden": !isExpanded ? true : undefined
    }), (0, _core.jsx)(_html.TdElement, {
      colSpan: columns.length + 1
    }, (0, _core.jsx)(_expander.ExpanderContent, {
      isExpanded: isExpanded,
      shouldAnimateImmediately: shouldAnimateImmediately,
      topSpacing: expandableRowHasTopBorder ? (0, _utils.getVerticalSpacingForCell)(spacing) : undefined
    }, (0, _core.jsx)(_layout.View, {
      padding: {
        bottom: (0, _utils.getVerticalSpacingForCell)(spacing)
      }
    }, ExpandableRowContent))));
  })) : null;
};

exports.ExpandableRowsByRows = ExpandableRowsByRows;